import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=23767343&"
import script from "./BaseFileInput.vue?vue&type=script&lang=js&"
export * from "./BaseFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports